import { createContext } from "react";
import { Api } from "./Api";

export const apiContext = createContext(
  new Api({ basePath: CONFIG.apiBaseUrl }),
);
